import { render } from "./AppImageCamera.vue?vue&type=template&id=bf71f040"
import script from "./AppImageCamera.vue?vue&type=script&lang=js"
export * from "./AppImageCamera.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__